import { Business, Home } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import { assets } from "../assets";
import { nextViewConnectBusinessState, updateConnectBusinessState } from "../redux/features/connectBusinessStateSlice";
import { roleColors, alphaVar } from "./ui/colors";
import Lottie from "react-lottie";
import { connectBusinessFlowColors } from "./connectBusinessFlowStyles";
import { Row } from "./quotes/quote-create-stepper/advanced-quote/quote-summary/ui/SummaryRow";

// import { appStates, setAppState } from "../redux/features/appStateSlice";

const images = [
  { icon: Business, title: "Commercial", type: "commercial", color: roleColors.commercial.base },
  { icon: Home, title: "Residential", type: "residential", color: roleColors.residential.base },
];

const ImageButton = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(20),
  height: theme.spacing(20),
  transition: "transform 180ms ease, box-shadow 180ms ease",
  boxShadow: theme.shadows[1],
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.up("md")]: {
    width: theme.spacing(18),
    height: theme.spacing(18),
  },
  [theme.breakpoints.up("lg")]: {
    width: theme.spacing(20),
    height: theme.spacing(20),
  },
}));

const OptionCard = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(2.5),
  borderRadius: 3,
  transition: "border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease",
  border: `1px solid ${connectBusinessFlowColors.border}`,
  background: connectBusinessFlowColors.band,
  boxShadow: "none",
  "&:hover": {
    borderColor: connectBusinessFlowColors.accent,
    transform: "translateY(-2px)",
    boxShadow: "none",
  },
}));

export default function ButtonConnectBusinessServices() {
  const dispatch = useDispatch();

  const handleOnClick = (type) => () => {
    // dispatch(setAppState({ currState: appStates.FINDACLEANER }));
    dispatch(updateConnectBusinessState({ serviceType: type }));
    dispatch(nextViewConnectBusinessState());
  };

  const handleKeyDown = (type) => (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleOnClick(type)();
    }
  };

  const images = [
    {
      icon: Business,
      title: "Commercial",
      type: "commercial",
      color: roleColors.commercial.base,
      animation: assets.animation.companymode,
      scale: 1.8,
      height: 200,
      width: 200,
      x: 8,
      y: 0,
    },
    {
      icon: Home,
      title: "Residential",
      type: "residential",
      color: roleColors.residential.base,
      animation: assets.animation.residentialmode,
      scale: 2.4,
      height: 115,
      width: 115,
      x: 8,
      y: 10,
    },
  ];

  return (
    <Grid container spacing={0} sx={{ width: "100%", marginTop: -5 }}>
      {images.map((image) => (
        <Grid
          item
          key={image.title}
          xs={12}
          sm={6}
          md={6}
          sx={{ display: "flex", alignItems: "stretch", justifyContent: "center", gap: 10, padding: 1 }}
        >
          <OptionCard elevation={0} sx={{ width: "100%", maxWidth: 340, borderRadius: 5, border: "none" }}>
            <Typography variant="h6" component="h3" sx={{ textAlign: "center", fontWeight: 700, color: connectBusinessFlowColors.text }}>
              {image.title}
            </Typography>

            <Tooltip title={`Choose ${image.title}`} arrow placement="top">
              <ButtonBase
                focusRipple
                onClick={handleOnClick(image.type)}
                onKeyDown={handleKeyDown(image.type)}
                aria-label={`Select ${image.title} service type`}
                sx={{
                  borderRadius: "50%",
                  outline: "none",

                  "&:focus-visible .MuiAvatar-root": (t) => ({
                    boxShadow: `0 0 0 4px ${t.palette.action.focus}, 0 0 0 6px ${t.palette.primary.main}33`,
                    transform: "scale(1.02)",
                  }),
                  "&:hover .MuiAvatar-root": {
                    transform: "scale(1.02)",
                  },
                  "&:active .MuiAvatar-root": {
                    transform: "scale(0.98)",
                  },
                }}
              >
                {/* <ImageButton sx={{ backgroundColor: alphaVar(image.color, 0.12) }}>
                  <image.icon
                    sx={{
                      fontSize: 64,
                      color: image.color,
                    }}
                  />
                </ImageButton>*/}

                <Box
                  sx={{
                    width: 200,
                    height: 110,

                    // border: `1px solid ${colors.orange[100]}`,
                    overflow: "hidden", // máscara
                    position: "relative",
                    margin: "auto",

                    //border: `1px solid ${connectBusinessFlowColors.border}`,
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: `translate(-50%, -50%) translate(${image.x || 0}px, ${image.y || 0}px) scale(${image.scale})`,
                      transformOrigin: "center",
                      margin: "auto",
                    }}
                  >
                    <Lottie
                      options={{
                        animationData: image.animation,
                        loop: true,
                      }}
                      height={image.height}
                      width={image.width}
                      sx={{ border: 1 }}
                    />
                  </Box>
                </Box>
              </ButtonBase>
            </Tooltip>

            <Box
              sx={{
                mt: 1.5,
                color: "text.secondary",
                fontSize: { xs: 13, md: 14 },
                textAlign: "center",
                px: 1,
              }}
            >
              Click or press Enter to continue
            </Box>
          </OptionCard>
        </Grid>
      ))}
    </Grid>
  );
}
